import { graphql, Link, useStaticQuery } from "gatsby";
import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

/* cspell: disable-next-line */
const altText = "صورة للمؤلف";

function Author({ isPrimary }) {
  const {
    strapiAuthor: { name, bio, avatar },
  } = useStaticQuery(graphql`
    query {
      strapiAuthor {
        name
        bio
        avatar {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 85
                height: 85
                quality: 100
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
  `);

  const imgAlt = `${altText} ${name}`;

  const imgLink = (
    <Link className="pt-2 rounded" to="/">
      <GatsbyImage
        image={getImage(avatar.localFile)}
        alt={imgAlt}
        className="rounded-full"
      />
    </Link>
  );

  return isPrimary ? (
    <div className="lg:w-full flex pr-4 md:pr-6 lg:pr-12 md:shadow-none shadow">
      {imgLink}
      <div className="pt-2 pr-3 lg:text-2xl md:text-xl text-dark leading-10 tracking-tighter">
        <strong className="font-semibold pb-2">{name}</strong>
        <p className="font-normal md:text-base lg:text-2xl">{bio}</p>
      </div>
    </div>
  ) : (
    <div className="lg:w-full flex mt-4">
      {imgLink}
      <div className="pr-3 pt-4 text-base text-dark leading-8">
        <strong>{name}</strong>
        <p>{bio}</p>
      </div>
    </div>
  );
}

export default Author;
